import React, { useState } from "react";
import { Container, Row, Col, Image, Modal } from "react-bootstrap";

function HomePage() {
  // Estado para controlar el modal del afiche
  const [showPosterModal, setShowPosterModal] = useState(false);

  const handleShowPosterModal = () => setShowPosterModal(true);
  const handleClosePosterModal = () => setShowPosterModal(false);

  return (
    <Container
      className="p-4 p-md-5 mb-4 bg-dark text-white rounded-5 shadow-lg border-0 mt-4"
      style={{ background: "linear-gradient(45deg, #212529 30%, #343a40 90%)" }}
    >
      <Row className="align-items-center">
        <Col lg={6} className="mb-4 mb-lg-0">
          <h1 className="display-5 fw-bold text-uppercase">
            CAMPEONATO SUDAMERICANO RC OFFROAD CHILE 2027
          </h1>
          <h2 className="h3 text-primary mb-4">
            9 al 13 de Junio | Calama, Chile
          </h2>
          <p className="lead fs-5 mb-3">
            Del 9 al 13 de junio de 2027, Calama será sede del Campeonato
            Sudamericano de RC Offroad.
          </p>
          <p className="fs-5 mb-3">
            Durante 5 días, los mejores pilotos de sudamerica se darán cita en
            el desierto de Atacama, en una pista preparada para competencia
            internacional y de alta exigencia técnica.
          </p>
          <p className="fs-5 mb-4">
            Un evento que reúne potencia, técnica y camaradería, en el corazón
            del norte de Chile.
          </p>
          <div className="mb-4">
            <h3 className="h5 fw-bold text-info mb-2">
              Categorías en competencia:
            </h3>
            <ul className="fs-5 mb-0">
              <li>Buggy Nitro 1/8</li>
              <li>Buggy Eco 1/8</li>
              <li>Buggy +45 (Master)</li>
              <li>Truggy Nitro 1/8</li>
              <li>Truggy Eco 1/8</li>
            </ul>
          </div>
          <p className="fs-5 fw-semibold fst-italic mb-0">
            Calama los espera para hacer historia en el RC sudamericano.
          </p>
        </Col>
        <Col lg={6} className="text-center">
          <div className="p-2 bg-white rounded-4 shadow-lg d-inline-block border border-light">
            <Image
              src="/afiche.jpg"
              fluid
              className="rounded-3"
              alt="Afiche Oficial Sudamericano 2027"
              onClick={handleShowPosterModal} // Abre el modal al hacer clic
              style={{ cursor: "pointer" }} // Indica que es clicable
            />
          </div>
        </Col>
      </Row>

      {/* Modal para mostrar el afiche ampliado */}
      <Modal
        show={showPosterModal}
        onHide={handleClosePosterModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Afiche Oficial Sudamericano 2027</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <Image
            src="/afiche.jpg"
            fluid
            alt="Afiche Oficial Sudamericano 2027"
          />
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default HomePage;
